import React, { memo } from 'react';
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormGroup,
  FormControlLabel,
  Switch,
} from '@mui/material';
import './table.scss';
import { AdimMealTimeProps } from '../../../../types/adminInterface';

const AdminMealtimeCharacteristicsTable: React.FC<AdimMealTimeProps> = ({
  data,
  handleSwitchChange,
}) => {
  return (
    <FormGroup className="table-wrapper AdminMealtimeCharacteristicsTable">
      <TableContainer component={Paper} className="table-inner" sx={{ maxHeight: 425 }}>
        <MuiTable stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Mealtime Sequence</TableCell>
              <TableCell>Mealtime Code</TableCell>
              <TableCell>Mealtime</TableCell>
              <TableCell>Dish Categories Applicable</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow key={row.sequencenumber}>
                <TableCell>{row.sequencenumber}</TableCell>
                <TableCell>{row.mealtimecode}</TableCell>
                <TableCell>
                  <input type="text" value={row.mealtimename} disabled />
                </TableCell>
                <TableCell>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={row.iscategoryapplicable}
                        onChange={() => handleSwitchChange(index)}
                        className={row.iscategoryapplicable ? 'active' : ''}
                      />
                    }
                    label={row.iscategoryapplicable ? 'Yes' : 'No'}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </MuiTable>
      </TableContainer>
    </FormGroup>
  );
};

export default memo(AdminMealtimeCharacteristicsTable);
